import {medicineReferences} from "../../hooks/medicineReferences.mjs";
import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import { Autoplay, Pagination } from "swiper";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { useSelector } from "react-redux";
import { PF } from "../../config";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLangPath } from "../../hooks/langAlias";
import { makeUrlFriendly } from "../../hooks/makeUrlFriendly";
import { mergeMedicineList } from "../../hooks/mergeMedicineList";
import LoadingBox from "../misc/Loading";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import {
  colors,
  fonts,
  radii,
  shadows,
} from "../../theme/designTokens";

export default function Banner() {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const xlUp = useMediaQuery(theme.breakpoints.up("xl"));

  // use State
  const [bannerLoading, setBannerLoading] = useState(false);
  const [lang, setLang] = useState("en");
  const [, setLangId] = useState("");
  const [medList, setMedList] = useState([]);
  const [catList, setCatList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const navigate = useNavigate();
  const lp = useLangPath();

  // Store
  const {
    medicines,
    categories,
    companies
  } = useSelector(
    (state) => state.medicine
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);

  // Functions
  const getCat = (subCatId) => {
    let cat = "";
    let subCat = "";
    catList.map((x) => {
      let Sc = x.subCatList.find(
        (sc) =>
          (lang && lang !== "en" ? sc.subCatDetectorId : sc.fixedSubCatId) ===
          subCatId
      );
      if (Sc) {
        subCat = Sc.subCatName;
        cat = x.catName;
      }
      return 0;
    });
    return { cat, subCat };
  };

  const getCompany = (companyId) => {
    if (companyList.length > 0) {
      let cName = "";
      let cImage = "";
      let C = companyList.find(
        (c) =>
          (lang && lang === "en" ? c.fixedCompanyId : c.companyDetectorId) ===
          companyId
      );
      if (C) {
        cName = C.companyName;
        cImage = C.companyLogo;
      }
      return { cName, cImage };
    }
    return "";
  };

  const getGenericBrand = (id) => {
    let genericBrand = "";
    const M = medicines.find((m) => m.lang === "en");
    if (M) {
      const med = M.data.find((x) => x.fixedMedicineId === id);
      if (med) genericBrand = med.genericBrand;
    }
    return genericBrand;
  };

  const handleViewMedicine = (x) => {
    navigate(
      lp(
        `/our-medicines/${makeUrlFriendly(
          getGenericBrand(
            lang !== "en" ? x.medicineDetectorId : x.fixedMedicineId
          )
        )}`
      )
    );
  };

  useEffect(() => {
    // if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    // dispatch(getMedCategories());
    // dispatch(getCompanies());
    // dispatch(getDosages());
  }, []);

  useEffect(() => {
    setBannerLoading(true);
    if (lang !== "" && medicines && medicines.length > 0) {
      const mergedData = mergeMedicineList(medicines, lang);
      if (mergedData.length > 0) {
        let arr = [...mergedData].sort((a, b) =>
          a.genericBrand.toLowerCase() > b.genericBrand.toLowerCase() ? 1 : -1
        );
        setMedList(
          arr.filter((a) => a?.dealOfTheWeek === true && a?.visible === true)
        );
      } else {
        setMedList([]);
      }
    }
    if (medicines) {
      setTimeout(() => {
        setBannerLoading(false);
      }, 1000);
    }
  }, [medicines, lang]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
      setLangId(activeLangFront.langId);
    }
  }, [activeLangFront]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      const C = {data: medicineReferences(categories, lang, "category")};
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  // Use Effect
  useEffect(() => {
    if (companies && companies.length > 0) {
      const C = {data: medicineReferences(companies, lang, "company")};
      if (C) setCompanyList(C.data);
    }
  }, [companies, lang]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  // Get Alt Tag
  const getSubCatString = (subCatArr) => {
    let subCatNameArr = [];

    const arr = [...subCatArr];
    arr.forEach((a) => {
      catList.forEach((x) => {
        let Sc = x.subCatList.find(
          (sc) =>
            (lang && lang !== "en" ? sc.subCatDetectorId : sc.fixedSubCatId) ===
            a.subCatId
        );
        if (Sc) {
          subCatNameArr.push(Sc.subCatName);
        }
      });
    });

    return subCatNameArr.join(", ") || "";
  };

  return (
    <>
      {bannerLoading ? (
        <LoadingBox w={"100%"} h={316} />
      ) : (
        medList.length > 0 && (
          <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: radii.md,
                  bgcolor: colors.primaryLight,
                  color: colors.primary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <LocalOfferOutlinedIcon />
              </Box>
              <Box>
                <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.4rem", color: colors.ink }}>
                  Featured Treatment
                </Typography>
                <Typography sx={{ fontSize: 13.5, color: colors.ink3 }}>
                  Limited-time prices on trusted brands
                </Typography>
              </Box>
            </Box>
          <Swiper
            slidesPerView={xlUp ? 3 : mdUp ? 2 : 1}
            grabCursor
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: 5000 }}
            loop={{ loop: true }}
            spaceBetween={16}
            pagination={{ clickable: true }}
            className="deal"
          >
            {medList.map((x, i) => (
              <SwiperSlide key={i}>
                <Box
                  sx={{
                    borderRadius: radii.lg,
                    boxShadow: shadows.card,
                    border: `1px solid ${colors.line}`,
                    bgcolor: colors.white,
                    my: 1,
                    overflow: "hidden",
                  }}
                >
                  <Grid container spacing={0}>
                    <Grid item xs={5}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: 220,
                          bgcolor: colors.white,
                          cursor: "pointer",
                        }}
                        onClick={() => handleViewMedicine(x)}
                      >
                        <LazyLoadImage
                          alt={
                            getSubCatString(x.subCats) +
                            " medicine " +
                            x.generic
                          }
                          effect="blur"
                          src={
                            x.image && x.image.length > 0
                              ? x.image[0]?.src !== "" &&
                                PF +
                                  "adminPanel/medicines/img/" +
                                  x.image[0].src
                              : PF +
                                "adminPanel/medicines/no-medicine-image.jpg"
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box sx={{ p: 2.25, display: "flex", flexDirection: "column", height: "100%", bgcolor: colors.paperTint }}>
                        <Typography
                          onClick={() => handleViewMedicine(x)}
                          sx={{
                            fontFamily: fonts.display,
                            fontWeight: 700,
                            fontSize: { xs: "0.95rem", sm: "1.1rem" },
                            color: colors.ink,
                            cursor: "pointer",
                          }}
                        >
                          {x.genericBrand.toUpperCase()}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: 12.5, sm: 13.5 }, color: colors.ink3, mt: 0.25 }}>
                          {translateFront("Generic")}: {x.generic}
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
                          {x.subCats &&
                            x.subCats.map(
                              (y, j) =>
                                getCat(y.subCatId).subCat && (
                                  <Typography
                                    key={j}
                                    component="span"
                                    sx={{ fontSize: 12, color: colors.ink3 }}
                                  >
                                    {getCat(y.subCatId).subCat +
                                      (j + 1 < x.subCats.length ? "," : "")}
                                  </Typography>
                                )
                            )}
                        </Box>
                        <Box sx={{ mt: 1.25 }}>
                          <LazyLoadImage
                            src={
                              getCompany(x.companyId).cImage &&
                              PF +
                                "/adminPanel/companies/" +
                                getCompany(x.companyId).cImage
                            }
                            alt={
                              getCompany(x.companyId).cName &&
                              getCompany(x.companyId).cName
                            }
                            effect="blur"
                            placeholderSrc={PF + "adminPanel/medicines/no-medicine-image.jpg"}
                            style={{
                              height: "28px",
                              objectFit: "cover",
                              borderRadius: "6px",
                            }}
                          />
                        </Box>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleViewMedicine(x)}
                          sx={{
                            alignSelf: "flex-start",
                            borderColor: colors.primary,
                            color: colors.primary,
                            borderRadius: radii.md,
                            textTransform: "none",
                            fontWeight: 700,
                            mt: 1.5,
                            "&:hover": { borderColor: colors.primary, bgcolor: colors.primaryLight },
                          }}
                        >
                          {translateFront("View")}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                  {/* </CardContent>
              </Card> */}
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
          </Box>
        )
      )}
    </>
  );
}
